import { type ReactNode, useState } from 'react';

import { Container, Message, StyledIconClose } from './messagePopup.styles';

interface MessagePopupProps {
  message: ReactNode;
  storageKey?: string;
}

const MessagePopup = ({ message, storageKey }: MessagePopupProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(() => {
    try {
      return storageKey ? !localStorage.getItem(storageKey) : true;
    } catch {
      return true;
    }
  });

  const closePopup = () => {
    if (storageKey) localStorage.setItem(storageKey, 'dismissed');
    setIsOpen(false);
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Container>
      <Message>{message}</Message>
      <StyledIconClose onClick={closePopup} />
    </Container>
  );
};

export default MessagePopup;
